




import Page from '../page/index.vue'
import { computed } from '@vue/composition-api'
import { defineClassComponent, useQuery } from '@/hooks'
import { Track } from '@/utils'

export default defineClassComponent(
  {
    components: {
      Page,
    },
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '店铺首页',
        }))
      }

      loading = computed(() => false)

      query = useQuery<{
        id: string
      }>({
        id: {
          default: '1605085094272159744',
        },
      })
    },
)
